import { PDF_BORDER, ReportPage, ReportTable, Text } from '@/components';
import { ReportBatchTargetLabelModifier } from '@/features/mold/models';
import type { OrganizingTableFormat2Props } from '@/features/mold/utils/pdf/pdf-components-props';
import { useLocaledAmount } from '@/providers';
import type { FC } from 'react';

export const OrganizingTableFormat2: FC<OrganizingTableFormat2Props> = ({
  header,
  body,
  footer,
  organizationNames,
  dateByCreated,
  paperSize,
}) => {
  const { unit } = useLocaledAmount();
  return (
    <ReportPage
      title={{
        text: ReportBatchTargetLabelModifier['rs-report2'],
        variant: 'footnote',
      }}
      layout={{
        paperSize,
        orientation: 'landscape',
      }}
      headerStyle={{ gap: 16 }}
      caption={{
        unit,
        item: <Text weight="bold" variant="small" text={organizationNames} />,
      }}
      dateByCreated={dateByCreated}
    >
      <ReportTable
        header={header}
        data={body}
        footer={footer}
        defaultBorderStyle={PDF_BORDER.THIN}
        tableWidth="100%"
        borderColor="secondary"
      />
    </ReportPage>
  );
};
